import { saveZohoConfig, getZohoConfig } from '../api/zoho-crm';

export const initializeZohoConfig = async (token) => {
  try {
    // Check if config already exists
    const existingConfig = await getZohoConfig(token);
    if (existingConfig.data) {
      return true;
    }
  } catch (error) {
    // Config doesn't exist, create it
  }

  try {
    // Your actual Zoho credentials
    const config = {
      clientId: "1000.Z3QJ3W8W1WBZ305WRVJJZMLQRHYJYO",
      clientSecret: "b241d30b3de6a0f987b93ad5774f32dc4b9fe490fe",
      refreshToken: "1000.7895c84bf5a232944e6d60404511f553.d0b1d26d5d2c3112a6f74fb6ce0a0e6e",
      apiDomain: "https://www.zohoapis.com"
    };

    await saveZohoConfig(config, token);
    return true;
  } catch (error) {
    console.error('Failed to setup Zoho CRM configuration:', error);
    return false;
  }
};